import React from 'react';
import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';

import { loadingState } from 'state/atoms';
import { UNFAVORITE_ADDRESS } from 'connectors/mutations/account';

import { Modal } from 'components/Modal';
import { useNotifyError } from 'utils/hooks';

const RemoveFavoriteAddressModal = ({
  onClose,
  favoriteId,
  afterRemoveAddress,
  ...props
}) => {
  const setLoading = useSetRecoilState(loadingState);
  const notifyError = useNotifyError({
    fallbackMessage: 'Unable to remove address from favorites.',
  });
  const [unfavoriteAddress] = useMutation(UNFAVORITE_ADDRESS);

  const handleModalConfirmation = () => {
    setLoading(true);
    unfavoriteAddress({
      variables: {
        addressId: favoriteId,
      },
    })
      .catch(notifyError)
      .finally(() => {
        afterRemoveAddress();
        onClose();
      });
  };

  return (
    <Modal
      title="Remove from favorites"
      content="Are you sure you want to remove this address from favorites?"
      flag="Warning"
      onConfirmation={handleModalConfirmation}
      onDismiss={onClose}
      onCancel={onClose}
      confirmButtonText="CONFIRM"
      {...props}
    />
  );
};

export { RemoveFavoriteAddressModal };
